export const productsDataSweets = [
  // プラントベース ミニケーキ 柚子
  {
    id: 7705872040190,
    title: 'プラントベース ミニケーキ 柚子',
    handle: 'de-0002-001',
    description:
      '植物由来の原材料で仕上げたさっぱりとした柚子の味わいが楽しめるプラントベースのミニケーキです。さわやかな柚子の香りが贅沢なひとときを彩ります。',
    published_at: '2022-06-07T16:16:34+09:00',
    created_at: '2022-06-07T16:16:34+09:00',
    vendor: '食+',
    type: '',
    tags: ['all', 'デザート', 'プラントベース', 'ミニケーキ'],
    price: 44000,
    price_min: 44000,
    price_max: 44000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 42893763772670,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7610992',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: 'プラントベース ミニケーキ 柚子',
        public_title: null,
        options: ['Default Title'],
        price: 44000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 41800,
              },
            ],
            price: 41800,
            compare_at_price: 44000,
            per_delivery_price: 41800,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 41800,
              },
            ],
            price: 41800,
            compare_at_price: 44000,
            per_delivery_price: 41800,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 41800,
              },
            ],
            price: 41800,
            compare_at_price: 44000,
            per_delivery_price: 41800,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0002-001_01.png?v=1655180954',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0002-001_03.png?v=1655185260',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0002-001_04.png?v=1655185260',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0002-001_01.png?v=1655180954',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/de-0002-001',
    media: [
      {
        alt: 'プラントベース ミニケーキ 柚子',
        id: 30068970914046,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0002-001_01.png?v=1655180954',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0002-001_01.png?v=1655180954',
        width: 1500,
      },
      {
        alt: 'プラントベース ミニケーキ 柚子_シーン',
        id: 30069129871614,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0002-001_03.png?v=1655185260',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0002-001_03.png?v=1655185260',
        width: 1500,
      },
      {
        alt: 'プラントベース ミニケーキ 柚子_個包装',
        id: 30069129904382,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0002-001_04.png?v=1655185260',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0002-001_04.png?v=1655185260',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回お届けプラン', '2週に1回お届けプラン', '4週に1回お届けプラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回お届けプラン',
            description: '週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回お届けプラン',
            description: '2週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回お届けプラン',
            description: '4週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '1個',
      },
      {
        title: '原材料',
        content:
          '豆乳加工食品（豆乳クリーム、植物油脂、水あめ、でん粉、食塩）(国内製造）、砂糖、ゆずピューレ、水あめ、米粉、ショートニング、アーモンドパウダー、寒天加工品／トレハロース、乳化剤、pH調整剤、セルロース、酸化防止剤（V.E）、塩化Mg、（一部にアーモンド・大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 125kcal、たんぱく質 1.0g、脂質 8.2g、炭水化物 11.7g、食塩相当量 0.05g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: false,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: true,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: true,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ裏面表示のアレルギー物質の記載内容が異なる場合がございます。お召し上がりの際は、必ず、お持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約φ50㎜×約H35㎜ / 37g',
      },
      {
        title: 'お召し上がり方法',
        content: '解凍してお召しあがりください。＜解凍時間の目安＞冷蔵庫（約5℃）2.5～3時間室温（約25℃）約1時間',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造ラインでは小麦・卵・乳成分を含む製品を製造しております。',
    allergy_caution: '',
  },
  // プラントベース ミニケーキ チョコ
  {
    id: 7705843794174,
    title: 'プラントベース  ミニケーキ チョコ',
    handle: 'de-0001-001',
    description:
      '植物由来の原材料で仕上げたプラントベースのチョコケーキ。クッキーのようなサクサクとした生地は、濃厚でリッチなチョコの味わいを引き立てます。食べた方を魅了する一品です。',
    published_at: '2022-06-07T15:32:26+09:00',
    created_at: '2022-06-07T15:31:04+09:00',
    vendor: '食+',
    type: '',
    tags: ['all', 'デザート', 'プラントベース', 'ミニケーキ'],
    price: 44000,
    price_min: 44000,
    price_max: 44000,
    available: true,
    price_varies: false,
    compare_at_price: null,
    compare_at_price_min: 0,
    compare_at_price_max: 0,
    compare_at_price_varies: false,
    variants: [
      {
        id: 42893654294782,
        title: 'Default Title',
        option1: 'Default Title',
        option2: null,
        option3: null,
        sku: '7610991',
        requires_shipping: true,
        taxable: true,
        featured_image: null,
        available: true,
        name: 'プラントベース  ミニケーキ チョコ',
        public_title: null,
        options: ['Default Title'],
        price: 44000,
        weight: 0,
        compare_at_price: null,
        inventory_management: 'shopify',
        barcode: '',
        requires_selling_plan: false,
        selling_plan_allocations: [
          {
            price_adjustments: [
              {
                position: 1,
                price: 41800,
              },
            ],
            price: 41800,
            compare_at_price: 44000,
            per_delivery_price: 41800,
            selling_plan_id: 3063906558,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 41800,
              },
            ],
            price: 41800,
            compare_at_price: 44000,
            per_delivery_price: 41800,
            selling_plan_id: 3063939326,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
          {
            price_adjustments: [
              {
                position: 1,
                price: 41800,
              },
            ],
            price: 41800,
            compare_at_price: 44000,
            per_delivery_price: 41800,
            selling_plan_id: 3064004862,
            selling_plan_group_id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
          },
        ],
      },
    ],
    images: [
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0001-001_01.png?v=1655176109',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0001-001_03.png?v=1655191875',
      '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0001-001_04.png?v=1655191875',
    ],
    featured_image: '//cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0001-001_01.png?v=1655176109',
    options: [
      {
        name: 'Title',
        position: 1,
        values: ['Default Title'],
      },
    ],
    url: '/products/de-0001-001',
    media: [
      {
        alt: 'プラントベース  ミニケーキ チョコ',
        id: 30068646707454,
        position: 1,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0001-001_01.png?v=1655176109',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0001-001_01.png?v=1655176109',
        width: 1500,
      },
      {
        alt: 'プラントベース  ミニケーキ チョコ_シーン',
        id: 30069459976446,
        position: 2,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0001-001_03.png?v=1655191875',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0001-001_03.png?v=1655191875',
        width: 1500,
      },
      {
        alt: 'プラントベース  ミニケーキ チョコ_個包装',
        id: 30068646772990,
        position: 3,
        preview_image: {
          aspect_ratio: 1,
          height: 1500,
          width: 1500,
          src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0001-001_04.png?v=1655191875',
        },
        aspect_ratio: 1,
        height: 1500,
        media_type: 'image',
        src: 'https://cdn.shopify.com/s/files/1/0638/1014/2462/products/DE-0001-001_04.png?v=1655191875',
        width: 1500,
      },
    ],
    requires_selling_plan: false,
    selling_plan_groups: [
      {
        id: 'd5602faa2a9f6ab65b8a555580b1546218877d9c',
        name: '定期購買プラン',
        options: [
          {
            name: '定期購買プラン',
            position: 1,
            values: ['週1回お届けプラン', '2週に1回お届けプラン', '4週に1回お届けプラン'],
          },
        ],
        selling_plans: [
          {
            id: 3063906558,
            name: '週1回お届けプラン',
            description: '週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '週1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3063939326,
            name: '2週に1回お届けプラン',
            description: '2週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '2週に1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
          {
            id: 3064004862,
            name: '4週に1回お届けプラン',
            description: '4週に1回商品をお届けします',
            options: [
              {
                name: '定期購買プラン',
                position: 1,
                value: '4週に1回お届けプラン',
              },
            ],
            recurring_deliveries: true,
            price_adjustments: [
              {
                order_count: null,
                position: 1,
                value_type: 'percentage',
                value: 5,
              },
            ],
          },
        ],
        app_id: null,
      },
    ],
    metafields: [
      {
        title: '内容量',
        content: '1個',
      },
      {
        title: '原材料',
        content:
          '豆乳加工食品（豆乳クリーム、植物油脂、水あめ、でん粉、食塩）（国内製造） 、砂糖、加工黒糖、水あめ、米粉、カカオマス、ショートニング、アーモンドパウダー、ココアパウダー、寒天加工品、アーモンド／トレハロース、乳化剤、pH調整剤、セルロース、酸化防止剤（V.E）、塩化Mg、（一部にアーモンド・大豆を含む）',
      },
      {
        title: '栄養成分（推定値）＊1個装当たり',
        content: 'エネルギー 147kcal、たんぱく質 1.4g、脂質 9.8g、炭水化物 13.3g、食塩相当量 0.05g',
      },
      {
        title: 'アレルギー表示',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
        allergy_items: [
          {
            title: 'えび',
            content: false,
          },
          {
            title: 'かに',
            content: false,
          },
          {
            title: 'くるみ',
            content: false,
          },
          {
            title: '小麦',
            content: false,
          },
          {
            title: 'そば',
            content: false,
          },
          {
            title: '卵',
            content: false,
          },
          {
            title: '乳成分',
            content: false,
          },
          {
            title: '落花生',
            content: false,
          },
          {
            title: 'アーモンド',
            content: true,
          },
          {
            title: 'あわび',
            content: false,
          },
          {
            title: 'いか',
            content: false,
          },
          {
            title: 'いくら',
            content: false,
          },
          {
            title: 'オレンジ',
            content: false,
          },
          {
            title: 'カシューナッツ',
            content: false,
          },
          {
            title: 'キウイフルーツ',
            content: false,
          },
          {
            title: '牛肉',
            content: false,
          },
          {
            title: 'ごま',
            content: true,
          },
          {
            title: 'さけ',
            content: false,
          },
          {
            title: 'さば',
            content: false,
          },
          {
            title: '大豆',
            content: true,
          },
          {
            title: '鶏肉',
            content: false,
          },
          {
            title: 'バナナ',
            content: false,
          },
          {
            title: '豚肉',
            content: false,
          },
          {
            title: 'まつたけ',
            content: false,
          },
          {
            title: 'もも',
            content: false,
          },
          {
            title: 'やまいも',
            content: false,
          },
          {
            title: 'りんご',
            content: false,
          },
          {
            title: 'ゼラチン',
            content: false,
          },
          {
            title: '魚介類',
            content: false,
          },
        ],
        content2:
          '★商品リニューアル等により、ホームページと商品パッケージ裏面表示のアレルギー物質の記載内容が異なる場合がございます。お召し上がりの際は、必ず、お持ちの商品の表示をご確認ください。',
      },

      {
        title: '商品の大きさ / 重量（1個当たり）',
        content: '約φ50㎜×約H35㎜ / 39g',
      },
      {
        title: 'お召し上がり方法',
        content: '解凍してお召しあがりください。＜解凍時間の目安＞冷蔵庫（約5℃）2.5～3時間室温（約25℃）約1時間',
      },
      {
        title: '賞味期限',
        content: '発送日から冷凍で90日以上※パッケージに記載',
      },
      {
        title: '保存方法',
        content: '要冷凍（-18℃以下）',
      },
      {
        title: '保存上の注意事項',
        content: '※‐18℃以下の冷凍庫で保存してください。※一度解凍したものは再び凍結しないでください。',
      },
      {
        title: 'アレルギー成分補足文言',
        content:
          'アレルギー物質は、食品表示基準に定められた表示義務のある8品目と、表示が推奨されている20品目をあわせた28品目に加え、魚介類を対象としています。',
      },
      {
        title: 'レシピ_1_画像',
        content: '',
      },
      {
        title: 'レシピ_2_画像',
        content: '',
      },
      {
        title: 'レシピ_1_タイトル',
        content: '',
      },
      {
        title: 'レシピ_2_タイトル',
        content: '',
      },
      {
        title: 'レシピ_1_材料',
        content: '',
      },
      {
        title: 'レシピ_2_材料',
        content: '',
      },
      {
        title: 'レシピ_1_作り方',
        content: '',
      },
      {
        title: 'レシピ_2_作り方',
        content: '',
      },
      {
        title: 'レシピ_1_概要',
        content: '',
      },
      {
        title: 'レシピ_2_概要',
        content: '',
      },
      {
        title: '商品ストーリーについて_本文',
        content: '',
      },
      {
        title: '商品ストーリーについて_タイトル',
        content: '',
      },
      {
        title: '商品ストーリーについて_画像',
        content: '',
      },
      {
        title: 'お届け方法',
        content: '冷凍（クール宅急便）',
      },
    ],
    allergy_note: '※本品製造ラインでは小麦・卵・乳成分を含む製品を製造しております。',
    allergy_caution: '',
  },
];
